import wacType from '../type/wac';
import quoteGQLString from '../util/quoteGQLString';

export default (ndc) => `
    wacsByNDC (ndc: ${quoteGQLString(ndc)}){
        ${wacType()}
    }
`;
